export const selectUserSuiteList = (state) =>
  state?.userSuites?.userSuiteList || [];

export const selectCurrentUserSuite = (state) =>
  state?.userSuites?.selectedUserSuite || {};
